import { render } from "./AllProcedures.vue?vue&type=template&id=d426e222&scoped=true"
import script from "./AllProcedures.vue?vue&type=script&lang=js"
export * from "./AllProcedures.vue?vue&type=script&lang=js"

import "./AllProcedures.vue?vue&type=style&index=0&id=d426e222&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d426e222"]])

export default __exports__